import { combineReducers } from "@reduxjs/toolkit";
import { enableES5 } from "immer";
import clientReducer, {
	storedKey as storedClient,
} from "./Containers/Client/reducer";
import appReducer, { storedKey as storedApp } from "./Containers/App/reducer";
import postReducer from "./Containers/PostContainer/reducer";
import homeReducer from "./Pages/Home/reducer";
import loginReducer from "./Pages/Login/reducer";
import registerReducer from "./Pages/Register/reducer";
import settingsReducer from "./Pages/Settings/reducer";
import exploreReducer from "./Pages/Explore/reducer";
import { mapWithPersistor } from "./persistance";

// * reducers that will stored to localStorage
const storedReducers = {
	app: { reducer: appReducer, whitelist: storedApp },
	client: { reducer: clientReducer, whitelist: storedClient },
};

const temporaryReducers = {
	login: loginReducer,
	register: registerReducer,
	post: postReducer,
	home: homeReducer,
	settings: settingsReducer,
	explore: exploreReducer,
};

export default function createRecuer(injectedReducer = {}) {
	enableES5();
	return combineReducers({
		...mapWithPersistor(storedReducers),
		...temporaryReducers,
		...injectedReducer,
	});
}
